<template>
	<FlowTreeActionBlock disabled :blockData="blockData" :appData="appData" :actionData="{}" hideStatus />
</template>

<script>
import FlowTreeActionBlock from './FlowTreeActionBlock.vue';
export default {
	name: 'FlowTreeVirtualBlock',
	props: { blockData: { type: Object }, appData: { type: Object } },
	components: { FlowTreeActionBlock },
};
</script>

<style lang="scss" scoped></style>
